<template>
  <div class="animated fadeIn sales-items">
    <b-card v-show="showList">
      <div slot="header">Sales Item (Posting Group) 
        <div class="card-header-actions">
          <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-row>
        <b-col lg="7">
            <b-input-group>
              <b-input-group-prepend><span class="p-2">Filter</span></b-input-group-prepend>
              <b-form-input v-model="filter" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
        </b-col>
      </b-row>

      <b-table
        class="mb-0"
        ref="table"
        outlined  responsive hover small
        style="font-size:smaller;" 
          :items="items"
        :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.pagelimit"
          :filter="filter"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"

        @row-clicked="rowClicked"
      >
        <template v-slot:cell(nomor)="data">
          {{ ((tblData.page-1)*tblData.limit)+data.index +1}}
        </template>
        <template v-slot:cell(saleCrCode)="data">
          {{ data.item.saleCrCode}} | {{ data.item.saleCrName}}
        </template>
        <template v-slot:cell(saleDefrCode)="data">
          {{ data.item.saleDefrCode}} | {{ data.item.saleDefrName}}
        </template>
        <template v-slot:cell(saleFeeCode)="data">
          {{ data.item.saleFeeCode}} | {{ data.item.saleFeeName}}
        </template>
        <template v-slot:cell(saleDiscCode)="data">
          {{ data.item.saleDiscCode}} | {{ data.item.saleDiscName}}
        </template>
        <template v-slot:cell(iklancetak)="data">
          <span v-if="data.item.iklancetak==1"><i class="fa fa-check "></i></span>
        </template>
        <template v-slot:cell(iklandigital)="data">
          <span v-if="data.item.iklandigital==1"><i class="fa fa-check "></i></span>
        </template>
        <template v-slot:cell(required_jadwal)="data">
          <span v-if="data.item.required_jadwal==1"><i class="fa fa-check "></i></span>
        </template>

        <template v-slot:cell(action)="data">
          <div class="text-center">
          <a href="javascript:void(0)" @click.stop="edit(data.item)">
            <i class="fa fa-pencil"></i>
          </a>
          |
          <a href="javascript:void(0)" class="text-danger" @click.stop="deleteConfirm(data.item)">
            <i class="fa fa-trash"></i>
          </a>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="6">
          <div>
            Showing {{(tblData.page - 1) * tblData.pagelimit + 1}}
            to <span v-if="((tblData.page * tblData.pagelimit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.pagelimit}}</span>
            of {{tblData.total}} entries
          </div>
        </b-col>
        <b-col cols="6">            
          <b-pagination
            align="right"
            :total-rows="tblData.total"
            :per-page="tblData.pagelimit"
            v-model="tblData.page"
          ></b-pagination>
        </b-col>
      </b-row>

      <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
        <p class="mb-1">1 record is about to be permanently deleted</p>
        <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
      </b-modal>
    </b-card>
    <b-card v-if="showForm">
      <div slot="header">Form - Sales Items (Posting Group) 
        <div class="card-header-actions">
          <button class="btn btn-primary mr-1" @click="save()">
            <i class="fa fa-save"></i> Save
          </button>
          <b-button class="btn btn-primary mr-1" @click="closeFrm()" > <i class="fa fa-close"></i> Close Form</b-button>
        </div>
      </div>
        <b-row >
          <b-col lg="6">
              <b-input-group >
                  <b-input-group-prepend><label>Sales Item Name</label></b-input-group-prepend>
                  <b-form-input v-model="frmdata.NamaSale" :state="!$v.frmdata.NamaSale.$error"></b-form-input>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Sales/Revenue Account</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.saleCrInfo" :state="!$v.frmdata.saleCrCode.$error"></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('saleCr')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Deffered/Unearned Revenue</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.saleDefrInfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('saleDefr')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Sales Commision/Fee Acc.</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.saleFeeInfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('saleFee')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
              <b-input-group >
                  <b-input-group-prepend><label>Sales Discount Account</label></b-input-group-prepend>
                      <b-form-input readonly v-model="frmdata.saleDiscInfo" ></b-form-input>
                      <b-input-group-append>
                      <b-btn text="Button" @click="showLkuCoa('saleDisc')" >
                          <i class="fa fa-search"></i>
                      </b-btn>
                      </b-input-group-append>
              </b-input-group>
          </b-col>
          <b-col lg="6">
              <b-input-group >
                  <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                <b-form-checkbox  class="ml-3 mt-2 mr-2" v-model="frmdata.required_jadwal" value="1" unchecked-value="0"><b>Sales Menyebutkan Jadwal</b></b-form-checkbox>
              </b-input-group>
              <b-input-group v-if="user.koran==1">
                  <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                <b-form-checkbox  class="ml-3 mt-2 mr-2" v-model="frmdata.iklancetak" value="1" unchecked-value="0"><b>Sales Iklan Cetak</b></b-form-checkbox>
              </b-input-group>
              <b-input-group v-if="user.iklan==1">
                  <b-input-group-prepend><label>&nbsp;</label></b-input-group-prepend>
                <b-form-checkbox  class="ml-3 mt-2 mr-2" v-model="frmdata.iklandigital" value="1" unchecked-value="0"><b>Sales Iklan Digital</b></b-form-checkbox>
              </b-input-group>
          </b-col>
      </b-row>
    </b-card>
        <b-modal v-model="lkuCoaShow" size="lg" :hide-footer="true" title="List of GL Account" :centered="true" :lazy="true">
            <lku-coa @click="onSelectLkuCoa" :tahun="tahun" :key="tahun"></lku-coa>
        </b-modal>        
  </div>
</template>
<style lang="scss">
  .sales-items {
      .input-group {
          padding-bottom:2px;
          .input-group-prepend {
              label {
                  padding-top: 5px;
                  padding-right: 5px;
                  width: 180px;
              }
          }
      }
  }
</style>


<script>
import lkuCoa from "../lookup/lkuCoa";
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

toastr.init();

export default {
  components: {lkuCoa},
  mixins: [validationMixin],
  validations: {
    frmdata: {
        NamaSale: { required },
        saleCrCode: { required },
    },
  }, 
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList:true,
      showForm:false,
      lkuCoaShow:false,
      lkuCoaCaller:'saleCr',
      tahun:(this.$store.state.user.tglaktif || '').substring(0,4),
      frmdata:{NamaSale: '',saleFeeCode: '', saleDefrCode: '', saleCrCode: '', saleDiscCode:'' },
      user: this.$store.state.user,
      tblData: {
        tablename:'salegroup',
        page: 1,
        pagelimit:20,
        limit: 1000,
        total: 0,
        sortBy: null,
        sortDesc: false,
      },
      items:[],
      filter: null,
    tblFields:[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "NamaSale",
            label: "Sales Group Name",
            sortable: true
          },
          {
            key: "saleCrCode",
            label: "Sales/Revenue Account",
            sortable: true
          },
          {
            key: "saleDefrCode",
            label: "Deffered/Unearned Account",
            sortable: true
          },
          {
            key: "saleFeeCode",
            label: "Sales Fee Account",
            sortable: true
          },
          {
            key: "saleDiscCode",
            label: "Discount Account",
            sortable: true
          },
        ]

    };
  },
  computed: {
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  created: async function() {
    if (this.user.koran==1){
        this.tblFields.push({
            key: "iklancetak",
            label: "Iklan Cetak",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          });
    }
    if (this.user.iklan==1){
      this.tblFields.push( 
          {
            key: "iklandigital",
            label: "Iklan Digital",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
      );      
    }
      this.tblFields.push( 
          {
            key: "required_jadwal",
            label: "Butuh Jadwal",
            thStyle: "width:80px",
            thClass: "text-center",
            tdClass: "text-center",
            sortable: true
          },
      );      
      this.tblFields.push( 
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          },
      );      
      this.data();
  },

  methods: {
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);     
      this.items= list; 
      // return list;
    },
    refresh(ctx) {
      // if (this.$refs.table) this.$refs.table.refresh();
      this.data();
    },
    add: function(data) {
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
      this.showForm=true;
      this.showList=false;
    },
    edit: async function(data) {
      this.model=data;
        for (var key in this.frmdata) {
            this.frmdata[key] = '';
        }
        for (var key in this.model) {
            this.frmdata[key] = this.model[key];
        }
      // this.frmdata.grouplama = data.groupname;
      this.frmdata.kodelama = data.kode;
      this.frmdata.saleDefrInfo = (data.saleDefrCode || '').trim() + ' | ' + (data.saleDefrName || '').trim();
      this.frmdata.saleCrInfo = (data.saleCrCode || '').trim() + ' | ' + (data.saleCrName || '').trim();
      this.frmdata.saleFeeInfo = (data.saleFeeCode || '').trim() + ' | ' + (data.saleFeeName || '').trim();
      this.frmdata.saleDiscInfo = (data.saleDiscCode || '').trim() + ' | ' + (data.saleDiscName || '').trim();
      // this.frmdata.PrePaymDbAccInfo = data.PrePaymDbAcc;
      // let _selected;
      // try {
      //   if (data.ApAccount) {
      //     _selected = await crud.findcoa({kodeacc: data.ApAccount, tahun: this.tahun});
      //     this.frmdata.ApAccountInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.ApUnBillCrAcc) {
      //     _selected = await crud.findcoa({kodeacc: data.ApUnBillCrAcc, tahun: this.tahun});
      //     this.frmdata.ApUnBillCrAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      //   if (data.PrePaymDbAcc) {
      //     _selected = await crud.findcoa({kodeacc: data.PrePaymDbAcc, tahun: this.tahun});
      //     this.frmdata.PrePaymDbAccInfo = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
      //   }
      // } catch (error) {
      //   if (error.message) {
      //       toastr.error(error.message);
      //   } else {
      //       toastr.error(JSON.stringify(error));
      //   }                      
      // }
      this.showForm=true;
      this.showList=false;

    },
    save: async function (callback) {
          if (this.invalidFormdata) {
              console.log('validation : ', this.$v.frmdata);
              console.log('frmdata : ',this.frmdata);
              toastr.error('Please fill the form correctly.', "ERROR MESSAGE");
        } else {
            try {
              if (this.frmdata.kodelama) {
                await crud.update(
                     {tablename:'salegroup', 
                     key:this.frmdata.kodelama, 
                     data:{NamaSale:this.frmdata.NamaSale,
                          saleDefrCode:this.frmdata.saleDefrCode,
                          saleDefrName:this.frmdata.saleDefrName,
                          saleCrCode:this.frmdata.saleCrCode,
                          saleCrName:this.frmdata.saleCrName,
                          saleFeeCode:this.frmdata.saleFeeCode,
                          saleFeeName:this.frmdata.saleFeeName,
                          saleDiscCode:this.frmdata.saleDiscCode,
                          saleDiscName:this.frmdata.saleDiscName,
                          iklancetak: this.frmdata.iklancetak || 0,
                          iklandigital: this.frmdata.iklandigital || 0,
                          required_jadwal: this.frmdata.required_jadwal || 0
                          }
                      });
              } else {
                await crud.insert(
                  { tablename:'salegroup',                      
                    data:{NamaSale:this.frmdata.NamaSale,
                          saleDefrCode:this.frmdata.saleDefrCode,
                          saleDefrName:this.frmdata.saleDefrName,
                          saleCrCode:this.frmdata.saleCrCode,
                          saleCrName:this.frmdata.saleCrName,
                          saleFeeCode:this.frmdata.saleFeeCode,
                          saleFeeName:this.frmdata.saleFeeName,
                          saleDiscCode:this.frmdata.saleDiscCode,
                          saleDiscName:this.frmdata.saleDiscName,
                          iklancetak: this.frmdata.iklancetak || 0,
                          iklandigital: this.frmdata.iklandigital || 0,
                          required_jadwal: this.frmdata.required_jadwal || 0
                          }
                  });
              }
              this.closeFrm();              
              setTimeout(() => {
                  this.refresh();              
              }, 500);       
            } catch (error) {
                if (error.message) {
                    toastr.error(error.message);
                } else {
                    toastr.error(JSON.stringify(error));
                }              
            }
        }
    },    
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({tablename:'salegroup', key:this.model.kode});
      this.refresh();
    },
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
          delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant= 'info';
      this.$forceUpdate();
    },
    showLkuCoa(callerObj)
    {
      this.lkuCoaShow=true;
      this.lkuCoaCaller=callerObj;
    },
    onSelectLkuCoa(_selected) {
            this.frmdata[`${this.lkuCoaCaller}Info`] = _selected.kodeacc.trim() + ' | ' + _selected.namaacc.trim();
            this.frmdata[`${this.lkuCoaCaller}Code`] = _selected.kodeacc;
            this.frmdata[`${this.lkuCoaCaller}Name`] = _selected.namaacc;
        this.lkuCoaShow=false;
    },
    closeFrm(){
      this.showForm=false;
      this.showList=true;
    },    
    close(){
      router.push({path:"home"});
    },    
  }
};
</script>
